import { CartAddEvent } from "@theme/events";
import { DialogCloseEvent } from "@theme/dialog";

/**
 * Enhances the app drawer used for the cart with auto-open on CartAddEvent.
 * The drawer itself is a standard <drawer-component> (from app-drawer.js).
 * Cart DOM updates are handled independently by <cart-items-component>.
 */
function initCartDrawer() {
  const cartDrawer = document.querySelector("drawer-component#cart-drawer");
  if (!cartDrawer) return;

  const cartDialog = cartDrawer.querySelector("dialog");

  document.addEventListener(CartAddEvent.eventName, (event) => {
    if (event.detail?.data?.didError) return;
    if (!cartDrawer.hasAttribute("auto-open")) return;

    // Adding from a size drawer closes it right after this event.
    // Wait for that drawer to close before opening the cart drawer
    // so the shared body scroll lock is not cleared.
    const openDialog = document.querySelector("dialog[open]");

    if (openDialog && openDialog !== cartDialog) {
      // DialogCloseEvent fires on the component, not on the <dialog> itself.
      const openDialogComponent = openDialog.closest("drawer-component, dialog-component, quick-add-dialog");

      if (openDialogComponent && openDialogComponent !== cartDrawer) {
        openDialogComponent.addEventListener(DialogCloseEvent.eventName, () => cartDrawer.open(), { once: true });
        return;
      }
    }

    cartDrawer.open();
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCartDrawer);
} else {
  initCartDrawer();
}
